<section class="pupil_choice">
  <div *ngIf="!letter" class="pupil_keyboard">
    <div class="page-title">
      <h1 *ngIf="!coach">Выбери первую букву своего имени</h1>
    </div>
    <div class="letters-container">
      <a class="letter-wrapper" *ngFor="let letter of letters" (click)="choiceLetter(letter)">
        <span>{{ letter }}</span>
      </a>
    </div>
  </div>
  <div *ngIf="letter" class="pupil_choice__students">
    <div class="page-title" *ngIf="!coach">
      <h1>Выбери себя</h1>
    </div>
    <div class="row pupil_choice-slider">
      <carousel style="width: 100%;">
        <slide>
          <div class="pupil_choice-slide-container col-4" *ngFor="let student of currentStudents; let i = index;">
            <div *ngIf="i <= 5" (click)="onChoice(student.id)" appDisTouchmove>
              <div class="pupil_choice-child boy">
                <div class="child-photo">
                  <img *ngIf="student?.avatar" src="{{ MAIN_DOMAIN }}{{ student.avatar }}" alt="">
                  <img *ngIf="!student?.avatar" src="{{ MAIN_DOMAIN }}{{ student.photo_url }}" alt="">
                </div>
                <div class="child-name text-center">
                  {{ student.short_name ? student.short_name : student.name}}<br/>
                  {{ student.surname }}
                </div>
              </div>
            </div>
          </div>
        </slide>
        <slide *ngIf="currentStudents.length > 6">
          <div class="pupil_choice-slide-container col-4" *ngFor="let student of currentStudents; let i = index;">
            <div *ngIf="i > 5 && i <= 11" (click)="onChoice(student.id)" appDisTouchmove>
              <div class="pupil_choice-child boy">
                <div class="child-photo">
                  <img *ngIf="student?.avatar" src="{{ MAIN_DOMAIN }}{{ student.avatar }}" alt="">
                  <img *ngIf="!student?.avatar" src="{{ MAIN_DOMAIN }}{{ student.photo_url }}" alt="">
                </div>
                <div class="child-name text-center">
                  {{ student.short_name ? student.short_name : student.name}}<br/>
                  {{ student.surname }}
                </div>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</section>

<a class="exit" (click)="onExit()">
  <span class="txt">Назад</span>
</a>


<!-- модалка для подтверждения выбранного коуча -->
<ng-template #confirmCoach>
  <mat-dialog-content class="confirm-coach__body">
    <span class="confirm-coach__body__pupil">
      <app-privilege-icon [student]="coachPupil" [lesson]="null"></app-privilege-icon>
      <p>{{ coachPupil.name }} <br> {{ coachPupil.middle_name }}</p>
    </span>
    <span class="confirm-coach__body__buttons">
      <button mat-raised-button
        (click)="abortChosedCoach()"
        class="confirm-coach__body__buttons__abort">Нет</button>
      <button mat-raised-button
        (click)="confirmChosedCoach()"
        class="confirm-coach__body__buttons__confirm">Да</button>
    </span>
  </mat-dialog-content>
</ng-template>

<ng-template #checkUser>
  <mat-dialog-content>
    <form class="check-user__form" [formGroup]="formCheckUser" (ngSubmit)="checkUserForm()">
      <p>Введите пароль выбранного пользователя</p>
      <mat-form-field hintLabel="Max 30 символов" appearance="outline">
        <mat-label><mat-icon>security</mat-icon> Пароль</mat-label>
        <input matInput #password placeholder="Ваш пароль" [type]="hide ? 'password' : 'text'" formControlName="password">
        <button class="icon-button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide">
          <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-hint align="end">{{ password.value?.length || 0 }}/30</mat-hint>
      </mat-form-field>
      <hr>
      <button
        class="registration-form__button"
        mat-raised-button matTooltip="Войти"
        matTooltipPosition="above"
        color="primary"
        [disabled]="!formCheckUser.valid">Войти</button>
    </form>
  </mat-dialog-content>
</ng-template>
